module.exports = __webpack_public_path__ + "img/po.fbcfc81b.png";